var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { Box, FormControl, FormLabel, Radio, RadioGroup, Stack, Tooltip } from 'shared/components';
import { enumLabelsAsOptions } from 'src/shared/utils';
import { UndoFormReason, UndoFormReasonLabels } from '../types';
export var UndoReason = function (_a) {
    var canChangeToDraft = _a.canChangeToDraft;
    var control = useFormContext().control;
    var options = enumLabelsAsOptions(UndoFormReasonLabels);
    return (_jsxs(FormControl, __assign({ mt: 3 }, { children: [_jsx(FormLabel, __assign({ fontWeight: "400" }, { children: "Why are you reverting this note?" })), _jsx(Controller, { control: control, name: 'reason', defaultValue: null, render: function (_a) {
                    var _b = _a.field, value = _b.value, name = _b.name, onChange = _b.onChange;
                    return (_jsx(RadioGroup, { children: _jsx(Stack, { children: options.map(function (_a) {
                                var optionValue = _a.value, label = _a.label;
                                return (_jsx(Tooltip, __assign({ maxW: "3xs", placement: "right", label: optionValue === UndoFormReason.arrivedLate && !canChangeToDraft
                                        ? 'This option is only available if you sign a ‘Client did not attend’ note template.'
                                        : '', hasArrow: true }, { children: _jsx(Box, __assign({ w: "fit-content" }, { children: _jsx(Radio, __assign({ "data-testid": optionValue, name: name, mr: 2, value: optionValue, isChecked: value === optionValue, isDisabled: optionValue === UndoFormReason.arrivedLate && !canChangeToDraft, onChange: function () {
                                                onChange(value === optionValue ? null : optionValue);
                                            } }, { children: label })) })) }), optionValue));
                            }) }) }));
                } })] })));
};
